module.exports = __webpack_public_path__ + "static/img/plan3.bde5551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/pengu/training-plan/plan3.png
// module id = YMge
// module chunks = 35